module.exports = __webpack_public_path__ + "static/media/icon-internet-fast.c812f875.svg";